import moment from 'moment'

/**
 * The delivery date a user captures when marking a Spare Part Sales line as Delivered (IS2-240).
 *
 * The date is compared by whole days: the picker gives a date, the request's creation date has
 * no meaningful time, and a delivery on the same day the request was created is valid.
 *
 * @param {object|string|null} date the chosen delivery date
 * @param {object|string|null} creationDate the request's creation date; skipped when missing
 * @returns {string|null} the validation message, or null when the date is valid
 */
export const validateDeliveryDate = (date, creationDate) => {
	if (!date) return 'The delivery date is required.'
	const deliveryDate = moment(date)
	if (!deliveryDate.isValid()) return 'Enter a valid delivery date.'
	if (deliveryDate.isAfter(moment(), 'day')) return 'The delivery date cannot be in the future.'
	if (creationDate && deliveryDate.isBefore(moment(creationDate), 'day')) {
		return "The delivery date cannot be earlier than the request's creation date."
	}
	return null
}

/**
 * The delivery date as the backend reads it from the line (ReleaseDate). Contract assumed pending
 * the backend part of IS2-240: a plain YYYY-MM-DD date inside SparePartParser.
 */
export const formatDeliveryDate = (date) => moment(date).format('YYYY-MM-DD')
